import React from "reactn";

import "../scss/container.scss";

const Container = React.forwardRef((props, ref) => <section {...props} ref={ref} id={props.id} className={"container " + props.className}>{props.children}</section>);

export default Container;